import { FC } from 'react';

import * as style from './style.css';
import { Card } from '../Card';
import { cardItems } from './constants';

export const Advantages: FC = () => {
  return (
    <div className={style['container']}>
      <div className={style['title']}> Преимущества приложения </div>
      <div className={style['content']}>
        {cardItems.map(item => (
          <Card key={item.name} card={item} />
        ))}
      </div>
    </div>
  );
};
